import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { Link, NavLink, useNavigate } from "react-router-dom";

import ProfileDropdown from "components/profileDropdown/ProfileDropdown";

import { ReactComponent as Logo } from "assets/images/logo.svg";
import { user } from "redux-store/user/user.selectors";
import { userClean } from "redux-store/user/user.slice";
import { petsClean } from "redux-store/pets/pet.slice";
import { useDispatch, useSelector } from "react-redux";

import { OC_TOKEN } from "utils/constants";
import { messageCleanUp } from "redux-store/auth/auth.slice";
import { AppDispatch } from "redux-store/store";

import "./Header.css";

type Props = {
  admin?: boolean;
};

const Header = ({ admin }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loggedInUser = useSelector(user);

  return (
    <div className="oc-header tw-text-[0.44rem]">
      <Navbar collapseOnSelect expand="lg" variant="dark" className="oc-header">
        <Container fluid className="px-xl-4 px-xxl-5 ">
          <Navbar.Brand className="oc-logo">
            <Link to={admin ? "/admin/dashboard" : "/user/home"}>
              <Logo className="tw-w-14 lg:tw-w-18" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          {loggedInUser?.isAdmin ? (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto" defaultActiveKey="#dashboard">
                <NavLink
                  to="/admin/dashboard"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Dashboard
                </NavLink>
                <NavLink
                  to="/admin/lab-result"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Lab Results
                </NavLink>
                <NavLink
                  to="/admin/activate-code"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Activation Code
                </NavLink>
                <NavLink
                  to="/admin/users"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Users
                </NavLink>

                <NavLink
                  to="/admin/orders"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Orders
                </NavLink>

                {!loggedInUser?.isAdmin && (
                  <NavLink
                    to={`/admin/my-profile/${loggedInUser?._id}`}
                    className={({ isActive }) => {
                      return isActive
                        ? "navlink-active min-[990px]:tw-hidden"
                        : "navlink-inactive min-[990px]:tw-hidden";
                    }}
                  >
                    My Account
                  </NavLink>
                )}

                <NavLink
                  to="/"
                  onClick={() => {
                    localStorage.removeItem(OC_TOKEN);
                    dispatch(messageCleanUp());
                    dispatch(userClean());
                    dispatch(petsClean());
                    navigate("/");
                  }}
                  className={({ isActive }) => {
                    return isActive ? "navlink-active min-[990px]:tw-hidden" : "navlink-inactive min-[990px]:tw-hidden";
                  }}
                >
                  Log Out
                </NavLink>
              </Nav>
              <Nav className="align-items-center oc-nav-right">
                <ProfileDropdown />
              </Nav>
            </Navbar.Collapse>
          ) : (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto " defaultActiveKey="#home">
                <NavLink
                  to="/user/home"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Home
                </NavLink>

                <NavLink
                  to="/user/pets"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  My Pets
                </NavLink>

                <NavLink
                  to="/user/lab-tests"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Lab Tests
                </NavLink>

                <NavLink
                  to="/user/activate/no"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Activate
                </NavLink>

                <NavLink
                  to="/user/care-team"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                  }}
                >
                  Vet Info
                </NavLink>
                {loggedInUser?.isHospital ? (
                  <NavLink
                    to="/user/hospital"
                    className={({ isActive }) => {
                      return isActive ? "navlink-active tw-text-xl" : "navlink-inactive tw-text-xl";
                    }}
                  >
                    Records
                  </NavLink>
                ) : (
                  ""
                )}

                <NavLink
                  to="https://oncotect.co/products/cancer-screening-test-kit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={({ isActive }) => {
                    return isActive ? "navlink-active tw-hidden" : "navlink-inactive tw-hidden";
                  }}
                >
                  Shop
                </NavLink>
                <div
                  className="tw-h-[1px] tw-w-[50%] tw-ml-[20%] tw-my-2 tw-mx-3 min-[990px]:tw-hidden"
                  style={{ backgroundColor: "white" }}
                ></div>
                <NavLink
                  to={`/user/my-profile/${loggedInUser?._id}`}
                  className={({ isActive }) => {
                    return isActive ? "navlink-active min-[990px]:tw-hidden" : "navlink-inactive min-[990px]:tw-hidden";
                  }}
                >
                  My Account
                </NavLink>

                <NavLink
                  to="/"
                  onClick={() => {
                    dispatch(messageCleanUp());
                    dispatch(userClean());
                    dispatch(petsClean());
                    localStorage.removeItem(OC_TOKEN);
                    navigate("/");
                  }}
                  className={({ isActive }) => {
                    return isActive ? "navlink-active min-[990px]:tw-hidden" : "navlink-inactive min-[990px]:tw-hidden";
                  }}
                >
                  Log Out
                </NavLink>
              </Nav>
              <Nav className="align-items-center tw-flex tw-flex-row oc-nav-right">
                <Nav.Item className="tw-hidden min-[990px]:tw-block">
                  <Button
                    href="https://oncotect.co/products/cancer-screening-test-kit"
                    className="oc-btn me-sm-3 me-xl-4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Shop
                  </Button>
                </Nav.Item>
                <ProfileDropdown />
              </Nav>
            </Navbar.Collapse>
          )}
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
